<div class="flex-align-center flex-space-between pad-M"
	 (mouseenter)="hovered = true"
	 (mouseleave)="hovered = false">
	<div class="flex-align-center">
		<div class="font-MM fw-700">{{ 'page.infrastructure.router.internetConnection' | translate }}</div>
		<div class="flex-center" style="height: 25px; width: 25px;"
			 [tooltip]="'page.infrastructure.router.internetConnectionTooltip'|translate">
			<img src="../../../../../../../../assets/icons/help-2.svg" class="info-bubble" width="14"
				 height="14" alt=""/>
		</div>
	</div>
	<app-multi-select *ngIf="formControl.value === null" [inputControl]="formControl"
					  [disabled]="_saving || !isEditor" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="isEditor" tooltipPosition="left">
		<app-button-widget select-trigger>
			<img *ngIf="isEditor" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="!isEditor" width="15" src="assets/icons/lock-01.svg">
		</app-button-widget>
		<app-select-option [value]="'yes'">
			<div class="flex-align-center p-absolute" style="left: 22px;">
				<div class="flex-align-center" style="width: 18px;">
					<img width="14" src="assets/icons/connected-to-internet.svg">
				</div>
				<span class="primary">Oui</span>
			</div>
		</app-select-option>
		<app-select-option [value]="'no'">
			<div class="flex-align-center">
				<div class="flex-align-center" style="width: 20px">
					<img width="18" src="assets/icons/not-connected-to-internet.svg">
				</div>
				<span class="primary">Non</span>
			</div>
		</app-select-option>
	</app-multi-select>
	<div *ngIf="formControl.value !== null" class="selection-trigger flex-align-center p-relative gap-XS">
		<div *ngIf="isEditor" [style.opacity]="hovered ? 1 : 0" class="flex-center p-absolute remove-btn c-p" (click)="formControl.setValue(null)">
			<img src="assets/icons/cross-black.svg" class="filter-white">
		</div>
		<img [width]="formControl.value === 'yes' ? 14 : 18" [src]="formControl.value === 'yes' ? 'assets/icons/connected-to-internet.svg' : 'assets/icons/not-connected-to-internet.svg'">
		<span class="fw-700 primary">{{ 'global.' + formControl.value | translate }}</span>
	</div>
</div>
